import State from './State'
export class Address {
    RequestTypeID: number;
    AddressTypeID: number;
    StreetNumber: string;
    StreetName: string;
    City: string;
    StateID?: number;
    State?: State;
    PostalCode: string;
    POBoxNumber: string;
    Supplemental: string;
    Latitude: number;
    Longitude: number;
    ID?: number;
    
}

export default Address;